export default __webpack_public_path__ + "static/media/figura_ce.6626d728.png";